export default "__VITE_ASSET__C3vuIYy2__"